import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = ["closeButton"]

  connect() {
    // Auto-remove flash message after 5 seconds
    this.timeout = setTimeout(() => {
      this.close()
    }, 5000)
  }

  disconnect() {
    // Clear timeout if component is removed before timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  close() {
    // Add fade-out animation
    this.element.style.transition = "opacity 0.3s ease-out"
    this.element.style.opacity = "0"
    
    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}

